import { useForm } from "react-hook-form";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { useEffect, useState } from "react";
import { Familiar } from "../../../models/fun/Familiar";
import { FuncionarioService } from "../../../service/ficha/FuncionarioService";
import { Panel } from "primereact/panel";
import { InputComponent } from "../../../components/InputComponent";
import { GenericComponent } from "../../../components/GenericComponent";
import { Generico } from "../../../components/Generico";
import { Button } from "primereact/button";

export const FamiliarEnfermedad = ({ id, toast, permss, opcion }) => {

    const generic = new GenericComponent();
    const omodel = new Familiar();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    let loadLazyTimeout = null;
    const funSrv = new FuncionarioService();
    const [registros, setRegistros] = useState(null);
    const [dialogFamiliar, setDialogFamiliar] = useState(false);
    const [familia, setFamilia] = useState(null);
    const { table, setLoading, setTotalRecords, lazyParams, inText } = InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyFamiliar();
    }, [id]);

    const editFamiliar = () => {
        funSrv.consultar(familia?.id, opcion, id).then(res => {
            reset(res.data);
            setDialogFamiliar(true);
        });
    }

    const loadLazyFamiliar = () => {
        setLoading(true);

        if (loadLazyTimeout) {
            clearTimeout(loadLazyTimeout);
        }

        let _lazyParams = lazyParams;
        _lazyParams.idp = id;

        loadLazyTimeout = setTimeout(() => {
            funSrv.listado({ lazyEvent: JSON.stringify(_lazyParams) }, opcion).then(res => {
                setTotalRecords(res.data.total);
                setRegistros(res.data.registros);
                setLoading(false);
            });
        });
    }

    const onSubmit = (data) => {
        data.idp = id;
        if (getValues('id') == null) {
            funSrv.nuevo(data, opcion).then(res => {
                setDialogFamiliar(false);
                loadLazyFamiliar();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            funSrv.editar(data, opcion).then(res => {
                setDialogFamiliar(false);
                loadLazyFamiliar();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const openNew = () => {
        setFamilia(null);
        setDialogFamiliar(true);
        reset(defaultValues);
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteFamiliar(familia?.id)
        });
    };

    const deleteFamiliar = () => {
        funSrv.eliminar(familia?.id, opcion, id).then(res => {
            loadLazyFamiliar();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && (!familia?.nemonico || familia.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFamiliar() } });
        if (permss?.eliminar && (!familia?.nemonico || familia?.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const headerTemplate = (options) => {
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" onClick={openNew} title="Registrar información"
                        style={{ display: permss?.crear ? 'block' : 'none' }} />
                    <span className="font-bold">Si tiene familiares dependientes con enfermedades permanentes, y/o tiene a su cuidado familiares con enfermedades permanentes, registre:</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <Panel headerTemplate={headerTemplate}>
                {table({ action01: accionesTbl, reg: setFamilia, items: itemsMenu() })}
            </Panel>

            <Dialog visible={dialogFamiliar} header={getValues('id') == null ? "Nueva Información" : "Editar Información"} modal className="p-fluid modal-ssize"
                onHide={e => setDialogFamiliar(false)} style={{ width: '400px' }}>
                <br />
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        {inText('nombre_completo', {}, 12)}
                        {inText('identificacion', {}, 12)}
                    </div>

                    {generic.buttonsForms(setDialogFamiliar)}
                </form>
            </Dialog>
        </>
    )
}
